import { DomainConfig } from '../config/domains';

/**
 * Deep merge function that overwrites values from source into target
 */
const deepMerge = (target: any, source: any): any => {
  const result = { ...target };
  
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(result[key] || {}, source[key]);
    } else {
      result[key] = source[key];
    }
  }
  
  return result;
};

/**
 * Merges domain-specific translations with base translations
 */
export const mergeTranslations = (
  baseTranslations: { [locale: string]: any },
  domainConfig: DomainConfig | null
): { [locale: string]: any } => {
  if (!domainConfig?.translations) {
    return baseTranslations;
  }

  const mergedTranslations: { [locale: string]: any } = {};

  // Process each locale
  for (const locale in baseTranslations) {
    mergedTranslations[locale] = deepMerge(
      baseTranslations[locale],
      domainConfig.translations[locale] || {}
    );
  }

  // Add any domain-specific locales that don't exist in base
  for (const locale in domainConfig.translations) {
    if (!mergedTranslations[locale]) {
      mergedTranslations[locale] = domainConfig.translations[locale];
    }
  }

  return mergedTranslations;
};